import cn from 'classnames';
import { type IOrderNotification } from '@/types/INotification';
import { getOrderToastSummary } from '@/utils/getOrderToastSummary';
import styles from './orderNotificationItem.module.scss';

interface IOrderNotificationItemProps {
  notification: IOrderNotification;
  onSelect: (path: string, id: string) => void;
}

/**
 * Карточка заказа в панели уведомлений. Статичная (без авто-скрытия), с
 * приглушением по `isRead`. Сводку заказа берёт из общего
 * `getOrderToastSummary` — DRY с тостом.
 */
export const OrderNotificationItem: React.FC<IOrderNotificationItemProps> = ({
  notification,
  onSelect
}) => {
  const summary = getOrderToastSummary(notification.payload.data);

  return (
    <button
      type="button"
      className={cn(styles['order-notification-item'], {
        [styles['order-notification-item_read']]: notification.isRead
      })}
      onClick={() => {
        onSelect(summary.orderPath, notification.id);
      }}
    >
      <span className={styles['order-notification-item__label']}>
        Новый заказ
      </span>
      <span className={styles['order-notification-item__title']}>
        {summary.title}
      </span>

      <div className={styles['order-notification-item__row']}>
        <span className={styles['order-notification-item__cost']}>
          {summary.totalCost}
        </span>
        {summary.recipientName !== null && (
          <span className={styles['order-notification-item__recipient']}>
            {summary.recipientName}
          </span>
        )}
      </div>

      {summary.firstOfferName !== null && (
        <span className={styles['order-notification-item__offer']}>
          {summary.firstOfferName}
          {summary.offersCount > 1 && (
            <span className={styles['order-notification-item__more']}>
              {` +${summary.offersCount - 1}`}
            </span>
          )}
        </span>
      )}
    </button>
  );
};
